import type { ProductTestResultApi } from '@ipen-portal/plugin-product-test-result-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const productTestResultApiRef = createApiRef<
  TRPCOptionsProxy<ProductTestResultApi>
>().with({
  id: 'plugin.ipen.product.test.result.api',
});
